import { listTypes } from '../thunks/types';
import { handleFulfilled, handlePending, handleRejected } from './utils';

export const typesReducers = (builder) => {
  // list property types
  builder
    .addCase(listTypes.fulfilled, (state, action) => handleFulfilled(state, 'types', action))
    .addCase(listTypes.pending, (state) => handlePending(state, 'types'))
    .addCase(listTypes.rejected, (state) => handleRejected(state, 'types'));
};
